import { defineFormConfig } from "@src/components/business-form";
import type { WsInvActContent } from "../../../../../../api/wsInvActs";

/** Значения формы элемента состава АИ (редактирование факт. количества). */
export interface WsInvActContentFormValues {
    factQty: number;
}

export const wsInvActContentFormConfig = defineFormConfig<WsInvActContentFormValues, WsInvActContent>({
    fields: {
        factQty: {
            type: "number",
            label: "Кол-во факт",
            validation: { required: true, min: 0 },
            map: "FactQty",
        },
    },
});
